import React, { useEffect } from 'react';
import { useRecordContext } from 'react-admin';
import { useFeatureGateContext } from 'providers/featureGateContext';

interface AssignmentRecord {
  id?: number | string;
  original_assignment_id?: number | string;
}

interface AssignmentFeatureGateContextProps {
  overrideAssignmentID?: number | string;
}

const AssignmentFeatureGateContext = ({
  overrideAssignmentID,
}: AssignmentFeatureGateContextProps): React.ReactElement | null => {
  const record = useRecordContext<AssignmentRecord>();
  const { setCustomIDs, statsigUser } = useFeatureGateContext();

  const originalAssignmentID = record?.original_assignment_id;
  const assignmentID = overrideAssignmentID ?? originalAssignmentID ?? record?.id;
  const currentAssignmentID = statsigUser?.customIDs?.assignment_id;

  useEffect(() => {
    if (!setCustomIDs) {
      return;
    }

    const nextAssignmentID = !!assignmentID ? String(assignmentID) : undefined;

    if (currentAssignmentID === nextAssignmentID) {
      return;
    }

    setCustomIDs(nextAssignmentID ? { assignment_id: nextAssignmentID } : undefined);
  }, [assignmentID, currentAssignmentID, setCustomIDs]);

  return null;
};

export default AssignmentFeatureGateContext;
